// extracted by mini-css-extract-plugin
module.exports = {"writeTel":"LeaveMessage_style_writeTel__3xIiX","item":"LeaveMessage_style_item__3CVfO","num":"LeaveMessage_style_num__28Fi-"};